module.exports = __webpack_public_path__ + "img/signECP.3d457adc.svg";